export default "__VITE_ASSET__LxNojnI6__"